import React from "react";
import "./loading.css";
export default function LoadingComponent(props) {
  return (
    <div className={`loading-container ${props.class}`}
    style={{
      height:props.mainLoaderHeight,
      width:props.mainLoaderHeight
    }}
    
    >
      <div id="loader"
      style={{
        height:props.loaderheight,
        width:props.loaderheight
      }}
      
      ></div>
    </div>
  );
}
   